
export function mapToRecord<K extends keyof any, V>(map: ReadonlyMap<K, V>): Record<K, V>;

export function mapToRecord<K extends keyof any, V, TK extends keyof any>(
  map: ReadonlyMap<K, V>,
  keyTransform?: (k: K) => TK): Record<TK, V>;

export function mapToRecord(map: ReadonlyMap<any, any>, keyTransform?: (k: any) => any): Record<any, any> {
  keyTransform ??= k => k;
  return [...map.entries()].reduce(
    (x, [k, v]) => { x[keyTransform(k)] = v; return x; },
    <Record<any, any>>{});
}
